module.exports = __webpack_public_path__ + "img/Woman-6.2ee69435.svg";